module.exports = __webpack_public_path__ + "static/media/icon-info.91df0b89.svg";